<template>
     
    <div class="container">
        <h1>How to use</h1>
        <div v-for="item in faqItems" :key="item.id" class="accordion-custom">
          <div class="accrodion" :class="{ active: showQuestion === item.id }">
  
            <div  class="accrodion-inner p-3  rounded mb-3 border border-secondary">
              <div class="accrodion-title">
    <h4 @click.prevent="OpenQuestion(item.id)">{{ item.title }}</h4>
  </div>
  
              <div class="accrodion-content" v-show="showQuestion === item.id">
                <div class="inner mt-3">
                  <img v-if="item.image" :src="item.image" :style="item.imgStyle" class="mb-4" />
                  <div v-html="item.content" class="faq-content"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
    
        <div class="text-center mt-5">
          <p>Can't find an answer? <a href="mailto:support@streamboxtv.live" class="text-info">Please send email to support@streamboxtv.live</a></p>
        </div>
      </div>
    </template>
    
    <script>
    export default {
      name: "FaqSupport",
      data() {
        return {
          showQuestion: 4,
          faqItems: [
  
            {
              id: 4,
              title: "Instructions",
              image: null,
              imgStyle: "",
              content: "",
            },
          ],
          instructionsHtml: `` // OVDE UBACI CEO ONAJ OGROMNI HTML TEKST KOJI SI POSLAO ZA ID=4
        };
      },
      mounted() {
  fetch('/instructions.html')
    .then(response => response.text())
    .then(html => {
      const instructionsItem = this.faqItems.find(item => item.id === 4);
      if (instructionsItem) {
        instructionsItem.content = html;
      }
    })
    .catch(error => {
      console.error("Failed to load instructions:", error);
    });
},

      methods: {
        OpenQuestion(id) {
          this.showQuestion = this.showQuestion === id ? null : id;
        },
      },
    };
    </script>
    
    <style scoped>
    *{
      color:white;
    
    }
 
    .accrodion-title {
      cursor: pointer;
    }
    .accrodion-title h4 {
      font-size: 1.2rem;
      margin: 0;
    }
    .accrodion-content {
      transition: all 0.3s ease-in-out;
    }
    .faq-content ul,
  
    .faq-content strong {
      color: #fff;
    }
    .accrodion-inner{
      background-color: #0f0f0f; /* Tamno siva pozadina */
    }
  
  
    header{
      color:white;
    }
    .mb-4 {
    margin-top: 20px;
  }
  h6{
      color:silver;
  }
  h1{
    text-align:center;
    padding:40px;
  }
  .container {
  width: 90vw;
  min-height: 100vh;

  padding: 40px 20px 100px 20px;
  box-sizing: border-box;
}

.accordion-custom {
  width: 100%;
}

    </style>
  
    